// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileTypeDto
 */
export interface IFileTypeDto {
    /**
     * 
     * @type {string}
     * @memberof IFileTypeDto
     */
    file_approval_type?: IFileTypeDtoFileApprovalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileTypeDto
     */
    file_extension_type?: IFileTypeDtoFileExtensionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileTypeDto
     */
    file_type?: IFileTypeDtoFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileTypeDto
     */
    file_processing_type?: IFileTypeDtoFileProcessingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFileTypeDto
     */
    file_processing_status_type?: IFileTypeDtoFileProcessingStatusTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IFileTypeDtoFileApprovalTypeEnum {
    MANUAL = 'MANUAL',
    AUTOMATED = 'AUTOMATED'
}
/**
* @export
* @enum {string}
*/
export enum IFileTypeDtoFileExtensionTypeEnum {
    CSV = 'CSV',
    UNSUPPORTED = 'UNSUPPORTED',
    TXT = 'TXT'
}
/**
* @export
* @enum {string}
*/
export enum IFileTypeDtoFileTypeEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum IFileTypeDtoFileProcessingTypeEnum {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL'
}
/**
* @export
* @enum {string}
*/
export enum IFileTypeDtoFileProcessingStatusTypeEnum {
    INITIATED = 'INITIATED',
    UPLOADED = 'UPLOADED',
    PARSED = 'PARSED',
    VALIDATED = 'VALIDATED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    QUALITY_GATES_FAILED = 'QUALITY_GATES_FAILED',
    ERROR = 'ERROR',
    DUPLICATE = 'DUPLICATE',
    CANCELLED = 'CANCELLED'
}


/**
 * Check if a given object implements the IFileTypeDto interface.
 */
export function instanceOfIFileTypeDto(value: object): value is IFileTypeDto {
    return true;
}

export function IFileTypeDtoFromJSON(json: any): IFileTypeDto {
    return IFileTypeDtoFromJSONTyped(json, false);
}

export function IFileTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_approval_type': json['file_approval_type'] == null ? undefined : json['file_approval_type'],
        'file_extension_type': json['file_extension_type'] == null ? undefined : json['file_extension_type'],
        'file_type': json['file_type'] == null ? undefined : json['file_type'],
        'file_processing_type': json['file_processing_type'] == null ? undefined : json['file_processing_type'],
        'file_processing_status_type': json['file_processing_status_type'] == null ? undefined : json['file_processing_status_type'],
    };
}

export function IFileTypeDtoToJSON(json: any): IFileTypeDto {
    return IFileTypeDtoToJSONTyped(json, false);
}

export function IFileTypeDtoToJSONTyped(value?: IFileTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_approval_type': value['file_approval_type'],
        'file_extension_type': value['file_extension_type'],
        'file_type': value['file_type'],
        'file_processing_type': value['file_processing_type'],
        'file_processing_status_type': value['file_processing_status_type'],
    };
}

